import { formatPath } from './utils';
import { AdminRouteNames } from './route-names';

import Admin from '../views/Admin.vue';
import PatientsList from '../views/PatientsList.vue';
import AdminHome from '../components/admin/Home.vue';
import AdminClients from '../components/admin/Customers.vue';
import Customer from '../components/admin/Customer.vue';
import AdminAnalytics from '../components/admin/Analytics.vue';
import AdminCommunication from '../components/admin/Communication.vue';
import AdminCampaigns from '../components/admin/Campaigns.vue';
import AdminConfigurations from '../components/admin/Configurations.vue';
import BusinessConfigurations from '../components/admin/BusinessConfigurations.vue';
import Vouchers from '../components/admin/Vouchers.vue';
import HelpCenter from '../components/admin/HelpCenter.vue';
import ViewAutomation from '../components/admin/ViewAutomation.vue';
import ShopManagement from '../components/admin/ShopManagement.vue';
import LoyaltyProgramManagement from '../components/admin/LoyaltyProgramManagement.vue';
import ReferralDashboard from '../components/admin/ReferralDashboard.vue';
import PaymentsPage from '../components/admin/pages/payments/PaymentsPage.vue';
import ConsentForms from '../components/admin/ConsentForms.vue';
import AuditExport from '../components/admin/pages/reports/AuditExport.vue';
import Integrations from '../components/admin/Integrations.vue';
import Team from '../components/admin/pages/team/Team.vue';
import TeamProfile from '../components/admin/pages/team/TeamProfile.vue';
import ResourceProfile from '../components/admin/pages/team/ResourceProfile.vue';
import More from '../components/admin/More.vue';
import Tasks from '../components/admin/pages/tasks/Tasks.vue';
import ManualCardChargePage from '../components/admin/pages/home/ManualCardChargePage.vue';
import { RouteRecordRaw } from 'vue-router';

export const adminRouter: RouteRecordRaw[] = [
  {
    path: '/patient-list',
    name: 'patient-list',
    component: PatientsList
  },
  {
    path: formatPath(AdminRouteNames.Admin),
    name: AdminRouteNames.Admin,
    component: Admin,
    children: [
      {
        name: AdminRouteNames.Home,
        path: '',
        component: AdminHome
      },
      {
        name: AdminRouteNames.BusinessConfigurations,
        path: 'business',
        component: BusinessConfigurations
      },
      {
        name: AdminRouteNames.ClientProfile,
        path: 'clients/:id',
        component: Customer
      },
      {
        name: AdminRouteNames.Analytics,
        path: 'analytics',
        component: AdminAnalytics
      },
      {
        name: AdminRouteNames.Clients,
        path: 'clients',
        component: AdminClients
      },
      {
        name: AdminRouteNames.Communication,
        path: 'communication',
        component: AdminCommunication
      },
      {
        name: AdminRouteNames.Campaigns,
        path: 'campaigns',
        component: AdminCampaigns
      },
      {
        name: AdminRouteNames.Automations,
        path: 'communication/:id',
        component: ViewAutomation
      },
      {
        name: AdminRouteNames.Configurations,
        path: 'configurations',
        component: AdminConfigurations
      },
      {
        name: AdminRouteNames.Vouchers,
        path: 'vouchers',
        component: Vouchers
      },
      {
        name: AdminRouteNames.ReferralProgram,
        path: 'referrals',
        component: ReferralDashboard
      },
      {
        name: AdminRouteNames.Shop,
        path: 'shop',
        component: ShopManagement
      },
      {
        name: AdminRouteNames.LoyaltyProgram,
        path: 'loyalty-program',
        component: LoyaltyProgramManagement
      },
      {
        name: AdminRouteNames.Integrations,
        path: 'integrations',
        component: Integrations
      },
      {
        name: AdminRouteNames.HelpCenter,
        path: 'help',
        component: HelpCenter
      },
      {
        name: AdminRouteNames.Tasks,
        path: 'tasks',
        component: Tasks
      },
      {
        name: AdminRouteNames.ManualCardCharge,
        path: 'charge-card/:uuid',
        component: ManualCardChargePage
      },
      {
        name: AdminRouteNames.Payments,
        path: 'payments',
        component: PaymentsPage,
      },
      {
        name: AdminRouteNames.ConsentForms,
        path: 'consent-forms',
        component: ConsentForms,
      },
      {
        name: AdminRouteNames.Reports,
        path: 'reports',
        component: AuditExport,
      },
      {
        name: AdminRouteNames.TeamProfile,
        path: 'team/:id',
        component: TeamProfile,
      },
      {
        name: AdminRouteNames.ResourceProfile,
        path: 'resource/:id',
        component: ResourceProfile,
      },
      {
        name: AdminRouteNames.Team,
        path: 'team',
        component: Team,
      },
      {
        name: AdminRouteNames.More,
        path: 'more',
        component: More,
      },
    ],
  },
];
